<div class="verification-modal" [class.d--hidden]="isLoading">
  <ng-container>
    <header class="modal__header">
      <h2 [ngStyle]="content && content.color && { color: 'black' }" id="modalLabel">
        {{ enableVerificationCodeSendAlternateReCaptcha ? content.alternateReCaptchaText?.title : content.text.title }}
      </h2>
      <button
        type="button"
        class="button modal__button--close"
        (click)="onCloseModal()"
        [attr.aria-label]="'general.label.close' | translate"
      >
        <i class="icon icon-ui-close--sm" [ngStyle]="content && content.color && { 'background-color': '#' + content.color.color }"></i>
      </button>
    </header>
    <div class="modal__content">
      <div
        class="modal__text"
        [internalInnerHtml]="enableVerificationCodeSendAlternateReCaptcha ? content.alternateReCaptchaText?.body : content.text.body"
        [userEventSource]="userEventSource"
      ></div>
      @if (!enableVerificationCodeSendAlternateReCaptcha) {
        <air-form
          #formComponent
          [controls]="form"
          [alternateReCaptchaActions]="alternateReCaptchaActions"
          [userEventSource]="userEventSource"
          (submitted)="submitValues($event)"
        >
        </air-form>
      }
      @if (enableVerificationCodeValidationAlternateReCaptcha || enableVerificationCodeSendAlternateReCaptcha) {
        <div class="form-group--grecaptcha">
          <air-recaptcha-fallback></air-recaptcha-fallback>
        </div>
      }
    </div>
    <div class="modal__footer--full-width-ends">
      @if (!enableVerificationCodeSendAlternateReCaptcha) {
        <button
          type="button"
          class="button button--secondary"
          [class.button--disabled]="isResendDisabled"
          [ngStyle]="content && content.color && { color: '#' + content.color.color }"
          [airButtonLoading]="isResendLoading"
          [disabled]="isResendDisabled"
          (click)="resendCode($event)"
        >
          <span>{{ 'account.label.resend_verification_code' | translate }}</span>
        </button>
      }
      <button
        type="submit"
        class="button form__button button--cta"
        [ngStyle]="content && content.color && { 'background-color': '#' + content.color.color }"
        [airButtonLoading]="isSubmitting"
        (click)="enableVerificationCodeSendAlternateReCaptcha ? sendCodeAlternateReCaptcha() : submit($event)"
      >
        <span>{{ submitLabel }}</span>
      </button>
    </div>
  </ng-container>
</div>
